(() => {
  if (window.beyondGenericFiltersBound) return;
  window.beyondGenericFiltersBound = true;
  const SALE = 'filter.p.m.custom.percent_discount_range';
  const brandSearch = new Map();
  const textOf = input => input.closest('li')?.querySelector('.facet-checkbox__text-label')?.textContent.trim() || input.value;
  const refreshMobileFeedback = () => {
    const form = document.querySelector('#FacetFiltersFormMobile');
    if (!form) return;
    const quick = form.querySelector('[data-beyond-size]');
    let sizes = [];
    try { sizes = JSON.parse(quick?.dataset.clothingSelection || '[]'); } catch {}
    const checked = [...form.querySelectorAll('input[type="checkbox"][name]:checked')];
    const groupedCategory = quick?.dataset.fourMainGroups === 'true' && sizes.length > 0;
    const others = checked.filter(input => input.name !== quick?.dataset.sizeParam && input.name !== SALE && input.name !== 'filter.v.availability' && !(groupedCategory && input.name === 'filter.p.product_type'));
    const prices = [...form.querySelectorAll('price-range input')].some(input => input.value);
    const sizeCount = sizes.length || (quick?.value && quick.value !== '__multiple' ? 1 : checked.filter(input => input.name === quick?.dataset.sizeParam).length);
    const hardnessCount = /(?:\/|\+)wheel-hardness-[^/+]+/.test(location.pathname) ? 1 : 0;
    const count = sizeCount + others.length + hardnessCount + (form.querySelector('[data-beyond-sale-toggle]')?.checked ? 1 : 0) + (prices ? 1 : 0);
    const open = document.querySelector('.mobile-facets__open');
    if (!open) return;
    let badge = open.querySelector('[data-beyond-filter-count]');
    if (!badge) { badge = document.createElement('span'); badge.dataset.beyondFilterCount=''; badge.className='beyond-mobile-filter-count'; open.append(badge); }
    badge.hidden = count === 0;
    if (badge.textContent !== String(count)) badge.textContent = String(count);
    badge.setAttribute('aria-label', count + ' selections');
  };
  window.beyondRefreshFilters = () => {
    const mobileView = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('#FacetFiltersForm,#FacetFiltersFormMobile').forEach(form => {
      if ((form.id === 'FacetFiltersFormMobile') !== mobileView) return;
      const quick = form.querySelector('[data-beyond-size]');
      form.querySelectorAll('details.js-filter').forEach(details => {
        const inputs = [...details.querySelectorAll('input[type="checkbox"][name]')];
        const param = inputs[0]?.name;
        const summary = details.querySelector('summary');
        if (!summary) return;
        if (!details.dataset.beyondInitialized) {
          details.dataset.beyondInitialized = 'true';
          if (form.id === 'FacetFiltersFormMobile') details.removeAttribute('open');
        }
        details.classList.toggle('beyond-hidden-filter', param === SALE);
        if (param === 'filter.p.vendor') details.classList.remove('beyond-hidden-filter');
        if (param === 'filter.p.product_type') {
          details.classList.add('beyond-category-filter');
          summary.querySelectorAll('span').forEach(span => {
            [...span.childNodes].filter(n=>n.nodeType===Node.TEXT_NODE && n.textContent.trim()==='Product type').forEach(n=>n.textContent='Category');
          });
          const legend=details.querySelector('legend'); if(legend) legend.textContent='Category';
        }
        if (param === 'filter.p.vendor') {
          summary.querySelectorAll('span').forEach(span=>{if(span.textContent.trim()==='Vendor')span.textContent='Brand';});
          if (inputs.length > 10) {
            details.classList.add('beyond-searchable-brand');
            let search = details.querySelector('[data-brand-search]');
            if (!search) {
              search = document.createElement('input');
              search.type='search'; search.dataset.brandSearch=''; search.placeholder='Find a brand'; search.setAttribute('aria-label','Find a brand');
              const list=details.querySelector('ul'); list?.before(search);
              search.addEventListener('input',event=>{
                event.stopImmediatePropagation();
                brandSearch.set(form.id,search.value);
                const term=search.value.trim().toLowerCase();
                const inputs=[...details.querySelectorAll('input[type="checkbox"][name]')];
                inputs.forEach(input=>input.closest('li').classList.toggle('beyond-search-hidden',!textOf(input).toLowerCase().includes(term)));
                let empty=details.querySelector('.beyond-brand-empty');
                if(!empty){empty=document.createElement('p');empty.className='beyond-brand-empty';empty.setAttribute('role','status');search.after(empty);}
                empty.textContent=inputs.some(i=>!i.closest('li').classList.contains('beyond-search-hidden'))?'':'No brands match.';
              });
            }
            search.value=brandSearch.get(form.id)||'';
            const term=search.value.trim().toLowerCase();
            inputs.forEach(input=>input.closest('li').classList.toggle('beyond-search-hidden',!textOf(input).toLowerCase().includes(term)));
          }
        }
        if (details.classList.contains('colour-filter')) {
          details.classList.add('beyond-colour-filter');
          inputs.forEach(input=>{
            const label=details.querySelector('label[for="'+CSS.escape(input.id)+'"]');
            if(!label)return;
            const name=textOf(input);
            input.setAttribute('aria-label',name); label.title=name;
            if(input.classList.contains('swatch-input__input') && !label.querySelector('.beyond-colour-name')){
              const span=document.createElement('span');span.className='beyond-colour-name';span.textContent=name;label.append(span);
            }
          });
        }
        summary.querySelector('.beyond-filter-selection')?.remove();
        const checked=inputs.filter(i=>i.checked);
        if(checked.length){
          const selected=document.createElement('span');selected.className='beyond-filter-selection';
          selected.textContent=checked.slice(0,2).map(textOf).join(', ')+(checked.length>2?' +'+(checked.length-2):'');
          summary.append(selected);
        }
        details.querySelectorAll('price-range .field__label').forEach((label,i)=>label.textContent=i?'Maximum':'Minimum');
      });
    });
    document.querySelectorAll('#FacetFiltersForm,#FacetFiltersFormMobile').forEach(form => {
      const brand = [...form.querySelectorAll('details.js-filter')].find(details => details.querySelector('input[name="filter.p.vendor"]'));
      const anchor = form.querySelector('.beyond-my-size') || form.querySelector('.beyond-skate-size-chooser') || form.querySelector('.beyond-sale-filter');
      if (brand && anchor && brand.parentElement === anchor.parentElement && brand.nextElementSibling !== anchor) anchor.before(brand);
      const sale = form.querySelector('.beyond-sale-filter');
      const size = form.querySelector('.beyond-my-size') || form.querySelector('.beyond-skate-size-chooser');
      if (sale && size && sale.parentElement === size.parentElement && size.nextElementSibling !== sale) size.after(sale);
      if (brand && !brand.dataset.beyondBrandClosed) {
        brand.removeAttribute('open');
        brand.dataset.beyondBrandClosed = 'true';
      }
      if (form.id === 'FacetFiltersFormMobile') {
        const sort = form.querySelector('.js-filter:has(.mobile-facets__sort)');
        const footer = form.querySelector('.mobile-facets__main > .mobile-facets__footer');
        if (sort && footer && sort.nextElementSibling !== footer) footer.before(sort);
      }
    });
    const quick = document.querySelector(window.matchMedia('(max-width: 749px)').matches ? '#FacetFiltersFormMobile [data-beyond-size]' : '#FacetFiltersForm [data-beyond-size]');
    const selected = quick?.selectedOptions[0];
    const clothingSizes = JSON.parse(quick?.dataset.clothingSelection || '[]');
    const sizeLabels = JSON.parse(quick?.dataset.sizeSelectionLabels || JSON.stringify(clothingSizes));
    if (clothingSizes.length || (selected?.dataset.sizeValues && JSON.parse(selected.dataset.sizeValues).length > 1)) {
      document.querySelectorAll('.active-facets-mobile,.active-facets-desktop').forEach(container => {
        const chips = [...container.querySelectorAll('facet-remove')].filter(c=>c.classList.contains('size-remove') || /^Size:/.test(c.textContent.trim()));
        chips.forEach((chip,index)=>{
          chip.classList.toggle('beyond-hidden-filter',index>0);
          if(index)return;
          const a=chip.querySelector('a'),inner=a?.querySelector('.active-facets__button-inner');
          if(!a||!inner)return;
          const url=new URL(a.href,location.origin);url.searchParams.delete(quick.dataset.sizeParam);url.searchParams.delete("b_truck_deck");url.searchParams.delete("b_clothing_sizes");url.searchParams.delete("b_footwear_sizes");a.href=url.pathname+url.search;
          [...inner.childNodes].filter(n=>n.nodeType===Node.TEXT_NODE).forEach(n=>n.remove());
          inner.prepend(document.createTextNode(clothingSizes.length ? 'Size: '+sizeLabels.join(', ')+' ' : (selected.dataset.sizeGroup||'Size')+': '+selected.textContent+' '));
        });
      });
    }
    // Keep the native filter values for Shopify, but expose one useful sale-removal control.
    document.querySelectorAll('.active-facets-mobile,.active-facets-desktop').forEach(container=>{
      const chips=[...container.querySelectorAll('facet-remove')].filter(chip=>chip.classList.contains('percent-discount-range-remove') || /Percent Discount Range/.test(chip.textContent));
      chips.forEach((chip,index)=>{
        chip.classList.toggle('beyond-hidden-filter',index>0);
        if(index)return;
        const link=chip.querySelector('a');if(!link)return;
        const url=new URL(link.href,location.origin);url.searchParams.delete(SALE);link.href=url.pathname+url.search;
        const inner=link.querySelector('.active-facets__button-inner');
        if(inner){[...inner.childNodes].filter(n=>n.nodeType===Node.TEXT_NODE).forEach(n=>n.remove());inner.prepend(document.createTextNode('On sale '));}
        link.setAttribute('aria-label','Remove On sale filter');
      });
    });
    const hardnessActive = /(?:\/|\+)wheel-hardness-[^/+]+/.test(location.pathname);
    document.querySelectorAll('[data-wheel-hardness] a').forEach(link => {
      const base = link.closest('[data-wheel-hardness]').dataset.collectionUrl;
      const slug = link.dataset.hardnessTag;
      if (!base || !slug) return;
      const tags = location.pathname.slice(new URL(base, location.origin).pathname.length).replace(/^\//, '').split('+').filter(Boolean);
      const active = tags.includes(slug);
      const next = tags.filter(tag => !tag.startsWith('wheel-hardness-'));
      if (!active) next.push(slug);
      const destination = new URL(base + (next.length ? '/' + next.join('+') : ''), location.origin);
      destination.search = location.search;
      destination.searchParams.delete('page');
      destination.searchParams.delete('section_id');
      link.href = destination.pathname + destination.search;
      if (active) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-beyond-clear-all]').forEach(link => {
      link.textContent = 'Clear all';
      if (hardnessActive) {
        const wrapper = link.closest('facet-remove');
        if (wrapper) wrapper.style.display = 'flex';
      }
    });
    const mixed = quick?.dataset.fourMainGroups === 'true' ? quick : null;
    let mainSizes = [];
    try { mainSizes = JSON.parse(new URLSearchParams(location.search).get('b_clothing_sizes') || '[]').filter(value => /^(Clothing|Waist|Shoes|Deck width):/.test(value)); } catch {}
    if (mixed && mainSizes.length) {
      document.querySelectorAll('.active-facets-mobile,.active-facets-desktop').forEach(container => {
        container.querySelectorAll('facet-remove.product-type-remove').forEach(chip => chip.classList.add('beyond-hidden-filter'));
        const chips = [...container.querySelectorAll('facet-remove.size-remove')];
        chips.forEach((chip,index) => {
          chip.classList.toggle('beyond-hidden-filter',index > 0);
          if (index) return;
          const link = chip.querySelector('a');
          const inner = link?.querySelector('.active-facets__button-inner');
          if (!link || !inner) return;
          const url = new URL(link.href);
          ['filter.p.product_type',mixed.dataset.sizeParam,'b_clothing_sizes','page'].forEach(key => url.searchParams.delete(key));
          link.href = url.pathname + url.search;
          [...inner.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
          inner.prepend(document.createTextNode(mainSizes.map(value => value.replace(':',' · ')).join(', ') + ' '));
        });
      });
      document.querySelectorAll('.beyond-category-filter .beyond-filter-selection').forEach(label => label.textContent = [...new Set(mainSizes.map(value => value.split(':')[0]))].join(', '));
    }
    refreshMobileFeedback();
  };
  document.addEventListener('input', event => {
    if (event.target.closest('#FacetFiltersFormMobile')) refreshMobileFeedback();
  });
  window.beyondRefreshFilters();
})();

